<template>
    <div v-if="isloaded">
        <div class="index-bg">
            <bb-searchbar></bb-searchbar>
        </div>
        <div class="container mt-5 mb-5">
            <mdb-jumbotron class="mb-0">
                <div class="content-page">
                    <h4 class="page-title">{{title}}</h4>
                    <mdb-tbl striped>
                        <mdb-tbl-head>
                            <tr>
                                <th>Nereden</th>
                                <th>Nereye</th>
                                <th>Tarih</th>
                                <th>Saat</th>
                                <th>#</th>
                            </tr>
                        </mdb-tbl-head>
                        <mdb-tbl-body>
                            <tr v-for="(bilet,index) in biletler" :key="index">
                                <th>{{bilet.from_code}}</th>
                                <td>{{bilet.to_code}}</td>
                                <td>{{bilet.departure_day}}</td>
                                <td>{{bilet.departure_time}}</td>
                                <td><a :href="'/#/reservation_check?booking_code='+bilet.booking_code+'&surname='+bilet.surname" >Detay</a></td>
                            </tr>
                        </mdb-tbl-body>
                    </mdb-tbl>
                </div>
            </mdb-jumbotron>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import { mdbTbl, mdbTblHead, mdbTblBody, mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption,mdbCollapse } from 'mdbvue';
    import searchBar from '@/components/searchBar';
    import { mdbDatatable } from 'mdbvue';
    import {TheMask} from "vue-the-mask";
    export default {
        name: 'ticketListPage',
        metaInfo() {
            return {
                title: "Biletlerim",
                meta: [
                    { name: 'description', content:  ""},
                    { name: 'keywords', content:  ""},
                    { property: 'og:title', content: ""},
                    { property: 'og:site_name', content: 'Biletbul'},
                    {property: 'og:type', content: 'website'},
                    {name: 'robots', content: 'index,follow'}
                ]
            }
        },
        components: {
            mdbTbl, mdbTblHead, mdbTblBody,
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            mdbCollapse,
            'bb-searchbar':searchBar,
            TheMask,
            mdbDatatable
        },
        data() {
            return {
                title: "Biletlerim",
                modal: false,
                toggle: false,
                isloaded : true,
                icerik:[],
                biletler:[],
                data: {
                    columns: [
                        {
                            label: 'Nereden',
                            field: 'from_code',
                            sort: 'asc'
                        },
                        {
                            label: 'Nereye',
                            field: 'to_code',
                            sort: 'asc'
                        },
                        {
                            label: 'Tarih',
                            field: 'departure_day',
                            sort: 'asc'
                        },
                        {
                            label: 'Saat',
                            field: 'departure_time',
                            sort: 'asc'
                        },
                        {
                            label: '#',
                            field: 'detail',
                            sort: 'asc',
                        }
                    ],
                    rows: []
                }
            }
        },
        mounted() {
            this.reservationCall();
        },
        methods:{
            async reservationCall() {
                let self = this;
                await axios.post("https://www.biletbul.com/backend/public/api/v1/reservation", {
                    api_token:localStorage.api_token,
                })
                    .then(function (response) {
                        if (response.data.status == true) {
                            self.biletler = response.data.data;
                        }
                        /*response => this.sessionAll = [response.data.data]*/
                    });
                /*this.params();*/
            }
        }
    }
</script>

<style scoped>

</style>